import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

interface GridCheckboxComponentParams extends ICellRendererParams {
  isDisabled: boolean;
}

// Work in progress component. Can be used as header or row checkbox.
@Component({
    selector: 'app-grid-checkbox',
    templateUrl: './grid-checkbox.component.html',
    styleUrls: ['./grid-checkbox.component.scss'],
    standalone: false
})
export class GridCheckboxComponent implements ICellRendererAngularComp {
  params: ICellRendererParams = {} as ICellRendererParams;
  isDisabled!: boolean;
  selectRow!: boolean; // This is future functionality. So that grid API selection can be synced with the checkboxes.

  constructor() {}

  refresh(params: ICellRendererParams) {
    params?.refreshCell?.();
    return false;
  }

  agInit(params: GridCheckboxComponentParams) {
    // console.log({ params }, 'checkbox agInit');
    this.params = params || ({} as GridCheckboxComponentParams);
    this.isDisabled = params.isDisabled;
  }

  toggleHandler(param: Event) {
    const target = param.target as HTMLInputElement;
    const colId = this?.params?.column?.getColId();
    const node = this.params.node;

    if (node && colId) {
      // Row node
      node.setDataValue(colId, target.checked);
    } else {
      this.params.value = target.checked;
      this.params.api.dispatchEvent({
        type: 'selectionChanged',
      });
    }

    // console.log('toggleHandler....', param, this.params);
  }
}
